module.exports = __webpack_public_path__ + "static/media/A18.04997d2b.png";